import { SupplierDetailPage } from '@/features/supplier/pages/SupplierDetailPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/supplier/$id/detail')({
  component: SupplierDetailPage,
})
